var exports = {
  "root": "x1cb7f6e3--b7ab2d--root",
  "root--size-m": "x1cb7f6e3--b7ab2d--root--size-m",
  "root--size-s": "x1cb7f6e3--b7ab2d--root--size-s",
  "logo": "x1cb7f6e3--b7ab2d--logo",
  "logo--shadow": "x1cb7f6e3--b7ab2d--logo--shadow",
  "count": "x1cb7f6e3--b7ab2d--count",
  "rest": "x1cb7f6e3--b7ab2d--rest",
};

module.exports = exports;
